import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export const CALLER_LABEL_MAX_LENGTH = 26;

export const useCallerLabelBaseText = () => {
  const { t } = useTranslation('phone');
  return t('Label displays on Weave phone screen and Call Pop while call is ringing');
};

export const isOverMaxLength = (value?: string, maxLength = CALLER_LABEL_MAX_LENGTH): boolean =>
  (value?.length ?? 0) > maxLength;

export const CallerLabelBaseText: React.FC<{ value?: string; error?: string }> = ({ value, error }) => {
  const baseText = useCallerLabelBaseText();

  if (!value || error || isOverMaxLength(value)) return null;

  return (
    <Text size='small' color='subdued' css={{ marginTop: theme.spacing(-3) }}>
      {baseText}
    </Text>
  );
};

export const useRemainingCharactersHelper = (value?: string, maxLength = CALLER_LABEL_MAX_LENGTH): string => {
  const { t } = useTranslation('phone');
  const baseText = useCallerLabelBaseText();

  if (!value) {
    return baseText;
  }

  const remaining = maxLength - value.length;

  if (isOverMaxLength(value, maxLength)) {
    return t('{{count}}/26 characters. Shorten label to 26 characters.', { count: value.length });
  }

  return t('{{remaining}}/{{maxLength}} characters remaining.', { remaining, maxLength });
};
